import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useQuery } from '@tanstack/react-query';
import { vehicleService } from '../../../application/VehicleService';
import { DriverCredentials } from '../../../domain/credentials/DriverCredentials';
import { useRetrieveVehicle } from './useRetrieveVehicle';

type UseRetrieveDriverCredentialsResponseProps = ServiceResponse<Function, DriverCredentials>;

// Hooks act as 'Adapter' layer.
export const useRetrieveDriverCredentials = (): UseRetrieveDriverCredentialsResponseProps => {
  const { data: vehicleData } = useRetrieveVehicle();

  const { data, isLoading, refetch, isSuccess, isError } = useQuery(
    [`driver_credentials`],
    () => vehicleService.retrieveCredentials(),
    {
      enabled: !!vehicleData,
      retry: false,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    }
  );

  return {
    error: isError,
    success: isSuccess,
    isLoading,
    run: refetch,
    data: data,
  };
};
